"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../helpers");
var castDateToISO_1 = __importDefault(require("./castDateToISO"));
var getDayDiff_1 = __importDefault(require("./getDayDiff"));
var isDateDisabled = function (_a) {
    var isoDate = _a.isoDate, maxDate = _a.maxDate, minDate = _a.minDate, disabledDates = _a.disabledDates, enabledDates = _a.enabledDates, maxSelectionLength = _a.maxSelectionLength, startDate = _a.startDate, endDate = _a.endDate;
    var date = new Date(isoDate);
    var isoMin = minDate && (0, castDateToISO_1.default)(minDate);
    var isoMax = maxDate && (0, castDateToISO_1.default)(maxDate);
    var isOutsideMaxSelection = maxSelectionLength &&
        startDate &&
        !endDate &&
        (0, getDayDiff_1.default)(startDate, date) > maxSelectionLength;
    var isDisabled = disabledDates &&
        (0, helpers_1.find)(disabledDates, function (date) { return (0, castDateToISO_1.default)(date) === isoDate; });
    var isEnabled = enabledDates &&
        (0, helpers_1.find)(enabledDates, function (date) { return (0, castDateToISO_1.default)(date) === isoDate; });
    return !!((isoMin && isoDate < isoMin) ||
        (isoMax && isoDate > isoMax) ||
        isOutsideMaxSelection ||
        isDisabled ||
        (enabledDates && !isEnabled));
};
exports.default = isDateDisabled;
